import http from "./support";

export default {
  googleDistanceCount(data) {
    return http.get("Schedule/googleDistanceCount/" + data);
  }
}
